import React, { Component, createRef } from 'react';

// CSS
import './Students.scss';

// Helper
import { checkCookie } from '../../Helper/Cookies';
import { apiFetch } from '../../Helper/Api';

// Components
import Header from '../../components/Header/Header';
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';

// Properties
const properties = require('../../properties.json');

const EVENT_LABEL = {
    INVALID_SIGNATURE: 'محاولة تحايل على تطبيق سطح المكتب',
    CAPTURE_ATTEMPT_KEYBOARD: 'محاولة تسجيل/تصوير شاشة (اختصار لوحة مفاتيح)',
    CAPTURE_ATTEMPT_PROCESS: 'برنامج تسجيل شاشة معروف كان شغال',
};

/** Review queue for content-theft signals detected against this teacher's own students -- see
 *  backend-hiilt-manasa-service's StudentService (strike/block logic) and
 *  frontend-hiilt-manasa-desktop's CaptureDetector/DesktopClientVerifier (what triggers a strike). */
class SecurityFlags extends Component {
    constructor(props) {
        super(props);
        this.toast = createRef(null);
    }

    state = {
        data: [],
    };

    getFlags = () => {
        apiFetch('/students/security-flags')
            .then((data) => this.setState({ data }))
            .catch((error) => console.error('Error:', error));
    };

    componentDidMount() {
        document.title = properties.site_name + ' | تنبيهات الأمان';
        if (!checkCookie('name')) {
            window.localStorage.removeItem('currentTeacher');
            window.location.href = `/`;
        }
        this.getFlags();
    }

    unblock = (studentProfileId) => {
        apiFetch(`/students/${studentProfileId}/unblock`, { method: 'POST' })
            .then(() => {
                this.toast.current.show({ severity: 'success', summary: 'تم', detail: 'تم فك الحظر عن الطالب' });
                this.getFlags();
            })
            .catch((error) => {
                console.error('Error:', error);
                this.toast.current.show({ severity: 'error', summary: 'تعذر', detail: 'حصل خطأ، حاول تاني' });
            });
    };

    render() {
        const statusBody = (row) => (
            <span className={`p-tag ${row.blocked ? 'p-tag-danger' : 'p-tag-warning'}`}>
                {row.blocked ? 'محظور' : 'تحت المراقبة'}
            </span>
        );
        const eventsBody = (row) => (
            <ul style={{ margin: 0, paddingRight: 18 }}>
                {(row.recentEvents || []).slice(0, 3).map((e, i) => (
                    <li key={i}>{EVENT_LABEL[e.eventType] || e.eventType}{e.detail ? ` — ${e.detail}` : ''}</li>
                ))}
            </ul>
        );
        const actionBody = (row) => (
            row.blocked ? (
                <Button label="فك الحظر" icon="pi pi-lock-open" className="p-button-success" onClick={() => this.unblock(row.studentProfileId)} />
            ) : null
        );

        return (
            <>
                <Header pageName="تنبيهات الأمان" />
                <Toast ref={this.toast}></Toast>
                <div className="content">
                    <div className="container">
                        <div className="card">
                            <Card title="طلاب يستحقون المراجعة (محاولات تسريب/تحايل مرصودة)">
                                <DataTable
                                    className="p-datatable-responsive-demo p-datatable-gridlines p-datatable-striped"
                                    value={this.state.data}
                                    paginator
                                    rows={10}
                                    emptyMessage="مفيش أي تنبيهات حاليًا"
                                >
                                    <Column field="fullName" header="اسم الطالب"></Column>
                                    <Column header="الحالة" body={statusBody}></Column>
                                    <Column field="securityStrikeCount" header="مخالفات تحايل"></Column>
                                    <Column field="captureAttemptCount" header="محاولات تسجيل شاشة"></Column>
                                    <Column field="blockCount" header="مرات الحظر (تاريخي)"></Column>
                                    <Column header="آخر الأحداث" body={eventsBody}></Column>
                                    <Column header="إجراء" body={actionBody}></Column>
                                </DataTable>
                            </Card>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default SecurityFlags;
